const GST_PERCENT = 18;
const CONVENIENCE_FEE_PERCENT = 2;

const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

const feesBeforeDeposit = (grossRent, pricing) => {
  const gross = round2(grossRent);
  const rentNet = gross;
  const gst = round2((rentNet * GST_PERCENT) / 100);
  const afterGst = round2(rentNet + gst);
  const convenience = round2((afterGst * CONVENIENCE_FEE_PERCENT) / 100);
  return round2(afterGst + convenience);
};

/**
 * Late return preview: 1 hour grace after scheduled drop-off, then hourly billing.
 * @returns {{ lateReturnHours: number, lateReturnSubtotalGross: number, lateReturnTotal: number } | null}
 */
export function computeRentalLateReturnCharge({ scheduledEnd, actualReturn, pricing }) {
  if (!scheduledEnd || !actualReturn) return null;

  const end = new Date(scheduledEnd);
  const returned = new Date(actualReturn);
  if (!Number.isFinite(end.getTime()) || !Number.isFinite(returned.getTime())) return null;
  if (returned.getTime() <= end.getTime()) return null;

  const graceEnd = new Date(end.getTime() + 60 * 60 * 1000);
  if (returned.getTime() <= graceEnd.getTime()) return null;

  const hourly = Number(pricing?.price_per_hour || 0) || 0;
  if (hourly <= 0) return null;

  const lateMs = returned.getTime() - graceEnd.getTime();
  const lateHours = Math.max(1, Math.ceil(lateMs / (1000 * 60 * 60)));
  const subtotalGross = round2(lateHours * hourly);

  return {
    lateReturnHours: lateHours,
    lateReturnSubtotalGross: subtotalGross,
    lateReturnTotal: feesBeforeDeposit(subtotalGross, pricing),
  };
}

export function bookingLateReturnTotal(booking) {
  return Number(booking?.late_return_total || 0) || 0;
}
